<template>
    <v-container class="KYCContainer">
        <v-card>
            <v-container fluid>
                <v-layout row wrap>
                    <v-flex xs12 sm12 md12>
                        <center>
                            <div class="container cards">
                                <v-layout row wrap style="place-content: center;">
                                    <v-flex xs12 sm12 md12 mb-4>
                                        <div class="icon_holder" style="padding-top: 2rem">
                                            <v-avatar color="primary-bg-light-1" size="100">
                                                <v-icon dark="" size="75">ID</v-icon>
                                            </v-avatar>
                                        </div>
                                   
                                    </v-flex>

                 

                                    <v-flex xs12 sm12 md12 mb-4>
                                        <img src="" class="ic-shadow " id="capturedPhoto1"  alt="Attachment" width="300">
                                        <div class="inputContainer headingExtra">
                                            <input type="file" accept="image/*" name="BotswanaNationalIdFront" class="fileInput hide" id="capture1" />
                                            <v-btn color="primary-btn" dark block class="text-none" @click="uploadNationalIdFront()" style="width: 40% !important"><b>National ID Front</b></v-btn>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12 mb-4>
                                        <img src="" class="ic-shadow" id="capturedPhoto2" alt="Attachment" width="300">
                                        <div class="inputContainer headingExtra">
                                            <input type="file" accept="image/*" name="BotswanaNationalIdBack" class="fileInput hide" id="capture2" />
                                            <v-btn color="primary-btn" dark block class="text-none" @click="uploadNationalIdBack()" style="width: 40% !important"><b>National ID Back</b></v-btn>
                                        </div>
                                    </v-flex>

                               <!-- <v-flex xs12 sm12 md12>
                                        <img src="" class="ic-shadow" id="capturedPhotoNationalID" style="margin:0 !important;display: none;" alt="Attachment" width="350">
                                        <div class="inputContainer headingExtra">
                                            <v-btn color="primary-btn"  dark block class="text-none" style="width: 40% !important; min-width: max-content;"  @click="capturenationalidfront()"  id="start-camera" ><b>National ID Front</b></v-btn>
                                        </div>
                                </v-flex> -->
                                <div style="color:red;" v-if="this.nationalIdFrontImgClicked == false && this.nationalIdBackImgClicked  == true" >
                                        Please upload Front side of National ID
                                </div>
                                
                                    <!-- <v-flex xs12 sm12 md12 mb-4>
                                        <img src="" class="ic-shadow" id="capturedPhotoNationalIDBack" style="margin:0 !important;display: none;" alt="Attachment" width="350">
                                        <div class="inputContainer headingExtra">
                                            <v-btn color="primary-btn"  dark block class="text-none" style="width: 40% !important; min-width: max-content;" @click="capturenationalidback()" ><b>National ID Back</b></v-btn>
                                        </div>
                                    </v-flex> -->

                                    <div style="color:red;" v-if="this.nationalIdFrontImgClicked == true && this.nationalIdBackImgClicked == false" >
                                        Please upload Back side of National ID
                                    </div>
                                </v-layout>
                            </div>
                            <v-layout row justify-center>
                                <v-flex xs6 sm6 md6 class="finalButton" id="final-btn" >
                                    <v-btn class="continue_button text-none" color="primary-btn" style="min-width: max-content;" dark block @click="submitimage(userid)" ><b>Upload Image</b></v-btn>
                                </v-flex>
                            </v-layout>
                            <div>
                                <ul style="list-style: none;">
                                    <li>
                                        <span>
                                        </span>
                                        <span>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                            <v-dialog persistent v-model="DocumentUploadFailureDailog" width="800">
                                <v-card>
                                    <v-card-title primary-title>
                                        <v-flex xs12 sm12 class="text-xs-center">
                                            <h2 class="commen-heading">Document(s) Upload Status </h2>
                                        </v-flex>
                                    </v-card-title>
                                    <v-card-text class="text-xs-center pt-0">
                                        <h3 class="grey--text text--darken-2">
                                            Error while processing documents
                                        </h3>
                                        <ul id="example-1" style="list-style-type: none;">
                                            <li v-for="(item, index) in uploadErrors" :key="index">
                                                {{ item }}
                                            </li>
                                        </ul>
                                    </v-card-text>
                                    <v-card-text class="pt-0">
                                        <v-container fluid class="pt-0">
                                            <v-layout row justify-center>
                                                <v-flex xs6 sm6 md6 class="pr-1">
                                                    <v-btn block color="primary-btn" dark class="text-none" @click="reupload()" >Re-Upload</v-btn>
                                                </v-flex>
                                                <v-flex xs6 sm6 md6 class="pl-1" >
                                                    <v-btn color="grey lighten-2" block class="text-none" @click="proceedwithoutreuploadMethod()" >Proceed Anyway</v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-dialog>

                            <v-dialog v-model="TotalUploadExceed" width="800">
                                <v-card>
                                    <v-card-title primary-title>
                                        <v-flex xs12 sm12 class="text-xs-center">
                                            <h2 class="commen-heading">Document(s) Upload Status </h2>
                                        </v-flex>
                                    </v-card-title>
                                    <v-card-text class="text-xs-center pt-0">
                                        <h3 class="grey--text text--darken-2">
                                            You have exceeded the maximum upload(s) limit.
                                        </h3>
                                    </v-card-text>
                                    <v-card-text class="pt-0">
                                        <v-container fluid class="pt-0">
                                            <v-layout row justify-center>
                                                <v-flex xs6 sm6 md6 class="pr-1">
                                                    <v-btn block color="primary-btn" dark class="text-none" @click="tolimitExceed()">OK</v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-dialog>
                            <v-dialog v-model="UploadStatus" width="800">
                                <v-card>
                                    <v-card-title primary-title>
                                        <v-flex xs12 sm12 class="text-xs-center">
                                            <h2 class="commen-heading">Service Status </h2>
                                        </v-flex>
                                    </v-card-title>
                                    <v-card-text class="text-xs-center pt-0">
                                        <h3 class="grey--text text--darken-2">
                                            {{UploadStatusMsg}}
                                        </h3>
                                    </v-card-text>
                                    <v-card-text class="pt-0">
                                        <v-container fluid class="pt-0">
                                            <v-layout row justify-center>
                                                <v-flex xs6 sm6 md6 class="pr-1">
                                                    <v-btn block color="primary-btn" dark class="text-none" @click="tolimitExceed()">OK</v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-dialog>

             <v-dialog scrollable persistent v-model="DocumentUploadFailureDailog1" v-show="DocumentUploadFailureDailog1" v-hide="!DocumentUploadFailureDailog1" id="KycErrorStatus">
            <v-card>
                <v-card-title primary-title>
                    <v-flex xs12 sm12 class="text-xs-center">
                        <h2 class="commen-heading"  style="font-size: 20px">KYC Status </h2>
                    </v-flex>
                </v-card-title>
                <v-card-text class="text-xs-center pt-0">
                    <h3 class="grey--text text--darken-2"  style="font-size: 14px"> 
                        <!-- Sorry you didn't pass the KYC test. Please follow the instructions carefully while re-upload. -->
                        {{ kycFailureMsg }}
                    </h3>
                </v-card-text>
                <v-card-text class="pt-0">
                    <v-container fluid class="pt-0" persistent>
                        <v-layout row justify-center>
                            <v-flex xs6 sm6 md6 class="pr-1">
                                <v-btn block color="primary-btn" dark class="text-none" @click="reuploadKycDocuments()" >Re-Upload</v-btn>
                            </v-flex>
                            <!-- <v-flex xs6 sm6 md6 class="pl-1" v-if="proceedwithoutreupload">
                                <v-btn color="grey lighten-2" block class="text-none" @click="proceedwithoutreuploadMethod()" >Proceed Anyway</v-btn>
                            </v-flex> -->
                        </v-layout>
                    </v-container>
                </v-card-text>
                
            </v-card>
        </v-dialog>

                        </center>
                    </v-flex>
                </v-layout>
                <!-- MODAL -->
                <div class="modal-backdrop" ref="modal" id="captureModal" data-keyboard="false" data-backdrop="static" v-show="isModalVisible">
               <div class="modal">
                  <header class="modal-header">
                     <button
                        type="button"
                        class="btn-close"
                        @click="close"
                        >
                     x
                     </button>
                  </header>
                  <section class="modal-body">
                     <slot name="body">
                        <!-- Video Element & Canvas -->
                        <div class="play-area">
                           <center>
                              <div class="play-area-sub">
                                 <video id="track" muted playsinline autoplay></video>
                              </div>
                           </center>
                        </div>
                        <div style="display:none">
                           <h3>The Capture</h3>
                           <canvas id="capture" ></canvas>
                           <div id="snapshot" ></div>
                        </div>
                     </slot>
                  </section>
                  <footer class="modal-footer">
                     <v-layout row justify-center>
                        <v-flex xs12 sm12 md6>
                           <v-btn v-if="this.nationalidfrontModal" color="primary-btn" dark block class="text-none" @click="captureNationalIDFrontImage()" id="click-photo" >Click Front photo</v-btn>
                           <v-btn v-if="this.nationalidBackModal" color="primary-btn" dark block class="text-none" @click="captureNationalIDBackImage()" id="click-photo" >Click Back photo</v-btn>
                        </v-flex>
                     </v-layout>
                  </footer>
               </div>
            </div>

            

            </v-container>
        </v-card>
        <div class="processingDiv" v-bind:class="{'show': processLoader==1||processLoader==2||processLoader==3||processLoader==4 ||processLoader==5}">
            <v-layout row wrap justify-center>
                <v-flex md4 class="text-xs-center">
                    <v-stepper class="elevation-0" v-model="processLoader" style="width:100%">
                        <v-stepper-items>
                            <v-stepper-content step="1">
                                <img :src="processLoader1" class="stepper-vector center-block" />
                                <h3 class="text-primary" >
                                    {{kycMessage}}
                                </h3>
                                <!--<v-btn @click="processLoader=2">NEXT</v-btn>-->
                            </v-stepper-content>
                            <v-stepper-content step="2">
                                <img :src="processLoader2" class="stepper-vector center-block" />
                                <h3 class="text-primary"  >
                                    {{kycMessage}}
                                </h3>
                                <!--<v-btn @click="processLoader=3">NEXT</v-btn>-->
                            </v-stepper-content>
                            <v-stepper-content step="3">
                                <img :src="processLoader3" class="stepper-vector center-block" />
                                <h3 class="text-primary"  >
                                    {{kycMessage}}
                                </h3>
                                <!--<v-btn @click="processLoader=4">NEXT</v-btn>-->
                            </v-stepper-content>
                            <v-stepper-content step="4">
                                <img :src="processLoader4" class="stepper-vector center-block" />
                                <h3 class="text-primary"  >
                                    {{kycMessage}}
                                </h3>
                                <!--<v-btn @click="processLoader=5">NEXT</v-btn>-->
                            </v-stepper-content>
                            <v-stepper-content step="5">
                                <img :src="processLoader5" class="stepper-vector center-block" />
                                <h3 class="text-primary"  >
                                    {{kycMessage}}
                                </h3>
                            </v-stepper-content>
                        </v-stepper-items>
                    </v-stepper>
                </v-flex>
            </v-layout>
        </div>

        <v-dialog v-model="dialogError">
            <v-card>
                <v-card-text>
                    <v-alert :value="true" color="error" icon="warning" outline>
                        {{ErrorMessage}}
                    </v-alert>
                </v-card-text>
                <v-card-actions>
                    <v-btn style="margin-right:auto;margin-left:auto" color="primary-btn" dark @click="ErrorpopUpOkButton()">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import router from '@/router';
import { db, externalURL } from '@/sunidhiapp';
// import axios from 'axios';
import '@/customJs/compressjs.js'
import jic from '@/customJs/JIC.min.js'
import $ from 'jquery';
import {readURL1, readURL2, readURL4, readURL10} from '@/customJs/kyc.js'
import '@/customJs/kyc.js'
import { state, methods } from '@/customJs/kyc.js';
import processLoader1 from '@/assets/images/process_loader-1.gif'
import processLoader2 from '@/assets/images/process_loader-2.gif'
import processLoader3 from '@/assets/images/process_loader-3.gif'
import processLoader4 from '@/assets/images/process_loader-4.gif'
import processLoader5 from '@/assets/images/process_loader-5.gif'

var isEmiratesExists = 0;
export default {
      name: 'kycPage',
      computed: {
    isDisableUploadBtn() {
      return state.isDisableUploadBtn;
    },
  },
      data: function () {
            return {
                userid: '0',
                kycMessage: "",
                kycTopMessage: "",
                btnSubmit: true,
                DocumentUploadFailureDailog: false,
                DocumentUploadFailureDailog1: false,
                kycFailureMsg: "",
                totUploadCount: 0,
                uploadErrors: [],
                panUploadFailed: true,
                fetchkycObject: "",
                TotalUploadExceed: false,
                UploadStatusMsg: "",
                UploadStatus: false,
                TimeCalculation: [],
                processLoader: 6,
                dialogError: false,
                ErrorMessage: "",
                passportfrontuploadfailed: true,
                passportbackuploadfailed: true,
                nationaliduploadfailed: true,
                nationalidbackuploadfailed: true,
                passportfrontuploadfailed1: true,
                passportbackuploadfailed1: true,
                nationaliduploadfailed1: true,
                nationalidbackuploadfailed1: true,
                isModalVisible: false,
                nationalIdFrontImgClicked: false,
                nationalIdBackImgClicked: false,
                nationalidfrontModal: true,
                nationalidBackModal: true,
                nationalIDFrontUploaded: false,
                nationalIDBackUploaded: false,
                uploadedImage1: false,
                uploadedImage2: false,
                IDDetailsOpt: [
                   { OptionValue: "Passport ID",OptionText: "Passport ID"},
                   { OptionValue: "National ID",OptionText: "National ID"}
                ],
                IDSelected: "",
                showUploadPassport: "",
                showNationalIDFrontAndBack: "",
                IDTypeOpt: [
                    { OptionValue:'National ID Front',OptionText:'National ID Front'},
                    { OptionValue:'National ID Back',OptionText:'National ID Back'},
                ],
                IDType : "",
                processLoader1: processLoader1,
                processLoader2: processLoader2,
                processLoader3: processLoader3,
                processLoader4: processLoader4,
                processLoader5: processLoader5
                // isDisableUploadBtn: true
            };
        },
        mounted: async function () {
            // $('#submitDocuments').hide();
            methods.setDisableUploadBtn(false);
            this.$sunidhi.logoutBtnDisp = true;
            // this.dispNextBtn = false;
            var genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
            if (genzdata != null || genzdata.length > 0) {
                if (typeof genzdata[0].token == 'undefined') {
                    this.userid = '0';
                }
                else {
                    this.userid = genzdata[0].token;
                }
            }
            else {
                this.userid = '0';
            }
            // await getLanguageSelected(this.userid);

              

             this.onready();
        },
        methods: {
            // ...methods,
            async ErrorpopUpOkButton() {
                this.ErrorMessage = "";
                this.dialogError = false;
            },
            tolimitExceed() {
                this.TotalUploadExceed = false;
                this.UploadStatus = false;
                this.UploadStatusMsg = "";
                // $('#submitDocuments').show();
                methods.setDisableUploadBtn(false);
                this.processLoader = 6;
            },
            async uploadNationalIdFront() {
                $('#capture1').click();
            },
            async uploadNationalIdBack() {
                $('#capture2').click();
                
            },
            reupload() {
                this.DocumentUploadFailureDailog = false;
                this.btnSubmit = true;
                // $('#step1').hide();
                this.processLoader = 6;
                this.nationalIDFrontUploaded = true;
                this.nationalIDBackUploaded = true;
                $('#capturedPhoto1').show();
                var element1 = document.getElementById('capturedPhoto1');
                element1.style.display = 'block !important';
               
                $('#capturedPhoto2').show();
                var element2 = document.getElementById('capturedPhoto1');
                element2.style.display = 'block !important';

                
                // $('#submitDocuments').show();
                methods.setDisableUploadBtn(false);
            },
            reuploadKycDocuments() {
                
                this.DocumentUploadFailureDailog1 = false;
                this.processLoader = 6;
                this.nationalIDFrontUploaded = true;
                this.nationalIDBackUploaded = true;
                $('#capturedPhoto1').show();
                var element1 = document.getElementById('capturedPhoto1');
                element1.style.display = 'block !important';
               
                $('#capturedPhoto2').show();
                var element2 = document.getElementById('capturedPhoto1');
                element2.style.display = 'block !important';
            },
            async proceedwithoutreuploadMethod() {
                this.processLoader = 6;
                this.DocumentUploadFailureDailog = false;
                //this.gotokyc();
                this.$sunidhi.logoutBtnDisp = true;
                router.push({ name: "HomeDataForm" });
            },
            async captureNationalIDFrontImage() {
              let cameraStream;
              cameraStream = await navigator.mediaDevices.getUserMedia({ video: true });
                if (null != cameraStream) {
                    var track = document.getElementById("track");
                    var capturedPhotoNationalID = document.getElementById("capturedPhotoNationalID");
                    var capture = document.getElementById("capture");

                    let width = cameraStream.getVideoTracks()[0].getSettings().width;
                    let height = cameraStream.getVideoTracks()[0].getSettings().height;


                    capture.height = height;
                    capture.width = width;
                    var ctx = capture.getContext('2d');
                    ctx.drawImage(track, 15, 37, 250, 180, 0, 0,width, height);

                    capturedPhotoNationalID.src = capture.toDataURL("image/png");
                    $("#capturedPhotoNationalID").show();
                   
                    this.nationalidfrontModal = false;
                    this.nationalIdFrontImgClicked = true;
                    if( state.isFrontImgUploaded == true &&  state.isBckImgUploaded == true){
                        // $('#submitDocuments').show();
                        methods.setDisableUploadBtn(false);
                        console.log("Front1:",state.isDisableUploadBtn)
                    } else {
                        // $('#submitDocuments').hide();
                        methods.setDisableUploadBtn(true);
                        console.log("Front2:",state.isDisableUploadBtn)
                    }
                   await this.close();
                }
            },
            async capturenationalidfront() {

              let cameraStream;
              cameraStream = await navigator.mediaDevices.getUserMedia({ video: true });
                this.nationalidfrontModal = true;
                this.nationalidBackModal = false;
                this.isModalVisible = true;
                var mediaSupport = 'mediaDevices' in navigator;
                let videoObj;

                var isMobile = /iPhone|Android/i.test(navigator.userAgent);
                var isTabDevice = /iPad|iPod/i.test(navigator.userAgent);
                if (!isMobile && !isTabDevice) {
                    videoObj = {
                        facingMode: 'user',
                        // width: 320,
                        // height: 240
                        width: 270,
                        height: 220
                    };
                } else if(isMobile) {
                    videoObj = {
                        facingMode: {
                            exact: 'environment'
                        },
                       width: 240,
                        height: 320
                        // width: 220,
                        // height: 270
                    };
                } else if(isTabDevice) {
                    videoObj = {
                        facingMode: {
                            exact: 'environment'
                        },
                        width: 320,
                        height: 240
                        // width: 270,
                        // height: 220
                    };
                }
                let constraintObj = {
                    audio: false,
                    video: videoObj
                };

                if (mediaSupport && null == cameraStream) {
                    navigator.mediaDevices.getUserMedia(constraintObj)
                        .then(function (mediaStream) {
                            cameraStream = mediaStream;
                            let trackStream = document.getElementById('track');
                            if ("srcObject" in trackStream) {
                                trackStream.srcObject = mediaStream;
                            } else {
                                //old version
                                trackStream.src = window.URL.createObjectURL(mediaStream);
                            }
                            trackStream.onloadedmetadata = function () {
                                //show in the video element what is being captured by the webcam
                                trackStream.play();
                            };
                            console.log("height: ", mediaStream.getVideoTracks()[0].getSettings().height);
                            console.log("width: ", mediaStream.getVideoTracks()[0].getSettings().width);
                        })
                        .catch(function (err) {
                            console.log("Unable to access camera: " + err);
                        });
                } else {
                    alert('Your browser does not support media devices.');
                    return;
                }
            },
            async captureNationalIDBackImage() {
              let cameraStream;
              cameraStream = await navigator.mediaDevices.getUserMedia({ video: true });
                if (null != cameraStream) {
                    var track = document.getElementById("track");
                    var capturedPhotoNationalIDBack = document.getElementById("capturedPhotoNationalIDBack");
                    var capture = document.getElementById("capture");

                    let width = cameraStream.getVideoTracks()[0].getSettings().width;
                    let height = cameraStream.getVideoTracks()[0].getSettings().height;


                    capture.height = height;
                    capture.width = width;
                    var ctx = capture.getContext('2d');
                    ctx.drawImage(track, 15, 37, 250, 180, 0, 0,width, height);

                    capturedPhotoNationalIDBack.src = capture.toDataURL("image/png");
                    $("#capturedPhotoNationalIDBack").show();
                    this.nationalidBackModal = false;
                    this.nationalIdBackImgClicked = true;
                    if( state.isFrontImgUploaded === true &&  state.isBckImgUploaded === true){
                        // $('#submitDocuments').show();
                        methods.setDisableUploadBtn(false);
                        console.log("Bck1:",state.isDisableUploadBtn)
                    } else {
                        // $('#submitDocuments').hide();
                        methods.setDisableUploadBtn(true);
                        console.log("Bck2:",state.isDisableUploadBtn)
                    }
                    await this.close();
                }
            },
            async capturenationalidback() {
                this.nationalidBackModal = true;
                this.nationalidfrontModal = false;
                this.isModalVisible = true;
                var mediaSupport = 'mediaDevices' in navigator;
                let videoObj;


               var isMobile = /iPhone|Android/i.test(navigator.userAgent);
                var isTabDevice = /iPad|iPod/i.test(navigator.userAgent);
                if (!isMobile && !isTabDevice) {
                    videoObj = {
                        facingMode: 'user',
                         // width: 320,
                        // height: 240
                        width: 270,
                        height: 220
                    };
                } else if(isMobile) {
                    videoObj = {
                        facingMode: {
                            exact: 'environment'
                        },
                        width: 240,
                        height: 320
                        // width: 220,
                        // height: 270
                    };
                } else if(isTabDevice) {
                    videoObj = {
                        facingMode: {
                            exact: 'environment'
                        },
                        width: 320,
                        height: 240
                        // width: 270,
                        // height: 220
                    };
                }
                let constraintObj = {
                    audio: false,
                    video: videoObj
                };
                let cameraStream;
              cameraStream = await navigator.mediaDevices.getUserMedia({ video: true });
                if (mediaSupport && null == cameraStream) {
                    navigator.mediaDevices.getUserMedia(constraintObj)
                        .then(function (mediaStream) {
                            cameraStream = mediaStream;
                            let trackStream = document.getElementById('track');
                            if ("srcObject" in trackStream) {
                                trackStream.srcObject = mediaStream;
                            } else {
                                //old version
                                trackStream.src = window.URL.createObjectURL(mediaStream);
                            }
                            trackStream.onloadedmetadata = function () {
                                //show in the video element what is being captured by the webcam
                                trackStream.play();
                            };
                            console.log("height: ", mediaStream.getVideoTracks()[0].getSettings().height);
                            console.log("width: ", mediaStream.getVideoTracks()[0].getSettings().width);

                        })
                        .catch(function (err) {
                            console.log("Unable to access camera: " + err);
                        });
                } else {
                    alert('Your browser does not support media devices.');
                    return;
                }
            },
            async close() {
              let cameraStream;
              cameraStream = await navigator.mediaDevices.getUserMedia({ video: true });
                this.isModalVisible = false;
                if (null != cameraStream) {

                    cameraStream.getTracks().forEach(function (track) {
                        track.stop();
                    });
                    cameraStream = null;
                }
            },
            async submitimage(userid) {
                // backbuttonpressed = false;
                // var objectSMS = [];

                

                if(!state.isFrontImgUploaded || !state.isBckImgUploaded) {
                    alert('Please upload both National ID front and back image');
                    return false;
                } 
             
                this.uploadErrors = [];
                var errorMsg = "Inconvenience is deeply regretted  for service unavailability.Kindly Re-upload the image."

              

                var genzdata = await db.TbGenz.where("token").anyOf(userid).toArray();
                $('#capturedPhoto1').show();
                $('#capturedPhoto2').show();
                if (genzdata != null && genzdata.length != 0) {
                    if (this.totUploadCount == 0) {
                        this.totUploadCount = (genzdata[0].totuploadCount == undefined || genzdata[0].totuploadCount == null) ? 0 : genzdata[0].totuploadCount;
                    }

                    this.totUploadCount += 1;

                    if (genzdata[0].totuploadCount >= 50) {
                        this.TotalUploadExceed = true;
                        return false;
                    } else {
                        await db.TbGenz.update(genzdata[0].PkId, { totuploadCount: this.totUploadCount });
                    }
                } else {
                    await db.TbGenz.update(genzdata[0].PkId, { totuploadCount: 0 });
                }

                const source_imageNationalID = $('#capturedPhoto1')[0];
                const source_imageNationalIDBack = $('#capturedPhoto2')[0];


                var resultNationalIDImage = jic.compress(source_imageNationalID, 90, '').src;
                var resultNationalIDImageBack = jic.compress(source_imageNationalIDBack, 90, '').src;

            
                var genzdata1 = await db.TbGenz.where("UserId").anyOf(1).toArray();

                var formData = new FormData();
                var facematchscrutinydoctype = "";
                var obj = new Object();

                this.processLoader = 1;
                this.kycMessage = "Uploading KYC Documents..";


              

                if (resultNationalIDImage.split(',')[1] != null && resultNationalIDImage.split(',')[1].length > 0) {
                    if (this.nationaliduploadfailed) {
                        obj.BotswanaNationalIdFront = resultNationalIDImage.split(',')[1];

                        if (facematchscrutinydoctype == null || facematchscrutinydoctype.length == 0) {
                            facematchscrutinydoctype = "BotswanaNationalIdFront";
                        }
                    }
                }

                if (resultNationalIDImageBack.split(',')[1] != null && resultNationalIDImageBack.split(',')[1].length > 0) {
                    if (this.nationalidbackuploadfailed) {
                        obj.BotswanaNationalIdBack = resultNationalIDImageBack.split(',')[1];

                        if (facematchscrutinydoctype == null || facematchscrutinydoctype.length == 0) {
                            facematchscrutinydoctype = "BotswanaNationalIdBack";
                        }
                    }
                }

                if (genzdata1 != null && genzdata1.length > 0) {
                    await db.TbGenz.update(genzdata1[0].PkId, {
                        BotswanaNationalIdFront: obj.BotswanaNationalIdFront,
                        BotswanaNationalIdBack: obj.BotswanaNationalIdBack });
                }

                var isIos = "False";

                var deviceAgent = navigator.userAgent.toLowerCase();
                var agentID = deviceAgent.match(/(iphone|ipod|ipad)/);
                if (agentID) {
                    isIos = "True";
                }
                formData.append('isios', isIos);

                var stringifyjson = JSON.stringify(obj);

                formData.append('data', stringifyjson);
                formData.append('userid', userid);
                formData.append('UploadType',"KycData");
                formData.append('PWAUserSessionId', genzdata[0].PWAUserSessionId);
                var fvformData = new FormData();
                fvformData.append('userid', userid);
                fvformData.append('scrutinydoctype', facematchscrutinydoctype);
                fvformData.append('PWAUserSessionId', genzdata[0].PWAUserSessionId);
                var self = this;

                /*starts */
                this.TimeCalculation = []
                // let uploadmultipledate,dateprocessfiles, facematch, fetch;
                // uploadmultipledate = new Date();



                /*ends */
                try {

                    $.ajax({
                        url: externalURL+'uploadmultiple/',
                        type: 'POST',
                        data: formData,
                        headers: {
                                        'Access-Control-Allow-Origin': '*',
                                        'Access-Control-Allow-Methods': 'GET,POST',
                                        'Access-Control-Allow-Headers': "Origin, X-Requested-With, Content-Type, Accept"
                                    },
                        processData: false,  // tell jQuery not to process the data
                        contentType: false,  // tell jQuery not to set contentType
                        success: function (dataupload) {
                            
                            
                            if(dataupload.PWAUserSessionStatus == "expired"){
                                 setTimeout(() => {
                                  self.PreLoader = false;
                                }, 500);
                                this.$sunidhi.logoutBtnDisp = false;
                                router.push({ name: 'SessionTimeout' });

                                }

                            if(dataupload.PWAUserSessionStatus == "Active"){

                            self.processLoader = 2;
                            self.kycMessage = "Upload Complete, Processing your KYC documents";


                            var doctypes = "";
                            var urlRun = externalURL +'processfiles/?userid=' + userid + '&isios=' + isIos + '&PWAUserSessionId=' + genzdata[0].PWAUserSessionId


                            if (self.totUploadCount > 1 && !self.nationaliduploadfailed1
                                && resultNationalIDImage.split(',')[1].length > 0) {
                                if (doctypes != null && doctypes.length > 0) {
                                    doctypes += ",BotswanaNationalIdFront";
                                } else {
                                    doctypes = "BotswanaNationalIdFront";
                                }
                            }

                            if (self.totUploadCount > 1 && !self.nationalidbackuploadfailed1
                                && resultNationalIDImageBack.split(',')[1].length > 0) {
                                if (doctypes != null && doctypes.length > 0) {
                                    doctypes += ",BotswanaNationalIdBack";
                                } else {
                                    doctypes = "BotswanaNationalIdBack";
                                }
                            }


                            if (doctypes != null && doctypes.length > 0) {
                                urlRun += "&doctypes=" + doctypes;
                            }

                            // eslint-disable-next-line no-unused-vars
                            let dateprocessfiles = new Date();

                            $.ajax({
                                url: urlRun,
                                type: 'POST',
                                success: function (datarun) {
                                    if(datarun.message == "Please re-upload proper National ID Back Image" || datarun.message == "Please re-upload proper National ID Front Image" || datarun.message == "Your ID card has been expired, please upload a valid ID card"){
                                        self.processLoader = 0;
                                        self.kycFailureMsg = datarun.message;
                                        self.DocumentUploadFailureDailog1 = true;
                                        $('#capturedPhoto1').show();
                                        $('#capturedPhoto2').show();
                                    } else {
                                    self.processLoader = 3;
                                    self.kycMessage = "Checking facematch";

                                    $.ajax({
                                        type: 'POST',
                                        url: externalURL+'facematch/',
                                        headers: {
                                        'Access-Control-Allow-Origin': '*',
                                        'Access-Control-Allow-Methods': 'GET,POST',
                                        'Access-Control-Allow-Headers': "Origin, X-Requested-With, Content-Type, Accept",
                                        "ngrok-skip-browser-warning": '69420'
                                    },
                                        data: fvformData,
                                        processData: false,
                                        contentType: false,
                                        success: async function (data) {
                                            self.processLoader = 4;
                                            self.kycMessage = "Fetching kyc data...";

                                            console.log("facematch %:", data);

                                            $.ajax({
                                                url: externalURL+'fetch/?userid=' + userid  + '&PWAUserSessionId=' + genzdata[0].PWAUserSessionId,
                                                type: 'POST',
                                                success: async function (fetchdata) {

                                                    self.processLoader = 5;
                                                    self.kycMessage = "Documents received. Redirecting...";

                                                    if (fetchdata.message == "Success") {

                                                        // var PAN = "";
                                                        // var AADHAAR = "";
                                                        // var HardcodedPAN = "";

                                                        var fetchdataobjects = fetchdata.result;
                                                        var fetchKycUploaded = fetchdataobjects
                                                    var genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
                                                        if (genzdata != null || genzdata.length != 0) {
                                                            await db.TbGenz.update(genzdata[0].PkId, { kycUpload : fetchKycUploaded });
                                                            // await db.TbGenz.update(genzdata[0].kycselected, { kycUpload : fetchKycUploaded });
                                                        }


                                                        if (resultNationalIDImage != null && resultNationalIDImage.split(',')[1].length > 0) {
                                                            if (typeof fetchdataobjects['BOTSWANANATIONALIDFRONT - Status'] != 'undefined' &&
                                                                fetchdataobjects['BOTSWANANATIONALIDFRONT - Status'] != 'Success') {
                                                                self.uploadErrors.push("NATIONAL ID Front");
                                                                self.nationaliduploadfailed1 = false;
                                                                self.nationaliduploadfailed = true;
                                                            } else {
                                                                self.nationaliduploadfailed = false;
                                                                self.nationaliduploadfailed = true;
                                                            }
                                                        }

                                                        if (resultNationalIDImageBack != null && resultNationalIDImageBack.split(',')[1].length > 0) {
                                                            if (typeof fetchdataobjects['BOTSWANANATIONALIDBACK - Status'] != 'undefined' &&
                                                                fetchdataobjects['BOTSWANANATIONALIDBACK - Status'] != 'Success') {
                                                                self.uploadErrors.push("NATIONAL ID Back");
                                                                self.nationalidbackuploadfailed1 = false;
                                                                self.nationalidbackuploadfailed = true;
                                                            } else {
                                                                self.nationalidbackuploadfailed = false;
                                                                self.nationalidbackuploadfailed = true;
                                                            }
                                                        }

                                                        if (self.uploadErrors != null && self.uploadErrors.length > 0) {
                                                            self.processLoader = 6;
                                                            self.fetchkycObject = fetchdataobjects;
                                                            self.DocumentUploadFailureDailog = true;
                                                            return false;
                                                        }
                                                        genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
                                                        if (genzdata != null || genzdata.length != 0) {
                                                            // eslint-disable-next-line no-undef
                                                            if (isEmiratesExists == 1) {
                                                                await db.TbGenz.update(genzdata[0].PkId, { nameinkyc: 'JOHN PERUMPILLIL SANTHOSH', idnoinkyc: '784-1971-2107590-3', nationalityinkyc: 'INDIAN' });
                                                            }
                                                            else {
                                                                if (typeof fetchdataobjects['livenessstatus'] != 'undefined') {
                                                                    await db.TbGenz.update(genzdata[0].PkId, { liveness: fetchdataobjects['livenessstatus'] });
                                                                }

                                                                if (typeof fetchdataobjects['fv_status'] != 'undefined') {
                                                                    await db.TbGenz.update(genzdata[0].PkId, { facematch: fetchdataobjects['fv_status'] });
                                                                }
                                                                if (typeof fetchdataobjects['fv_confidence'] != 'undefined') {
                                                                    await db.TbGenz.update(genzdata[0].PkId, { facematchPercentage: fetchdataobjects['fv_confidence'] });
                                                                }

                                                                var orderarray = ["INDIAPASSPORTFRONT","BOTSWANANATIONALIDFRONT","BOTSWANANATIONALIDBACK"];
                                                                var varnameinkyc = "";
                                                                var tempname = "";
                                                                for (i = 0; i < orderarray.length; i++) {                             
                                                                    if (orderarray[i] == 'INDIAPASSPORTFRONT') {
                                                                      tempname = 'INDIAPASSPORTFRONT - Given Name';
                                                                      if(typeof fetchdataobjects[tempname] != 'undefined'){
                                                                      varnameinkyc = fetchdataobjects[tempname];
                                                                      }
                                                                                                        
                                                                      tempname = 'INDIAPASSPORTFRONT - Surname';
                                                                      if(typeof fetchdataobjects[tempname] != 'undefined'){
                                                                      varnameinkyc = varnameinkyc+" "+fetchdataobjects[tempname];
                                                                      }
                                                                    await db.TbGenz.update(genzdata[0].PkId, { nameinkyc: varnameinkyc });
                                                                                    
                                                
                                                                    }
                                                                    else {
                                                                        tempname = orderarray[i] + ' - Name';
																		
                                                                    
                                                                    if (typeof fetchdataobjects[tempname] != 'undefined') {
                                                                      varnameinkyc = fetchdataobjects[tempname];
                                                                      console.log('Name works',varnameinkyc);

                                                                      await db.TbGenz.update(genzdata[0].PkId, { nameinkyc: varnameinkyc });
                                                                      break;
                                                                    }
                                                                  }
                                                                }

                                                                if (typeof fetchdataobjects['INDIAPASSPORTFRONT - Passport No'] != 'undefined') {
                                                                    await db.TbGenz.update(genzdata[0].PkId, { passportnoinkyc: fetchdataobjects['INDIAPASSPORTFRONT - Passport No'] });
																	await db.TbGenz.update(genzdata[0].PkId, { idnoinkyc: fetchdataobjects['INDIAPASSPORTFRONT - Passport No'] });
                                                                }

                                                                var vardoeinkyc = "";
                                                                var tempdoe = "";
                                                                for (i = 0; i < orderarray.length; i++) {
                                                                    tempdoe = orderarray[i] + ' - Date of Expiry';
                                                                    if (typeof fetchdataobjects[tempdoe] != 'undefined') {
                                                                        vardoeinkyc = fetchdataobjects[tempdoe];
                                                                        await db.TbGenz.update(genzdata[0].PkId, { passportdateexpiryinkyc: vardoeinkyc });
                                                                        break;
                                                                    }
                                                                }


                                                                // var varidnoinkyc = "";
                                                                var tempid = "";
                                                                // var AADHAAR = "";
                                                                for (i = 0; i < orderarray.length; i++) {
                                                                    if (orderarray[i] == 'BOTSWANANATIONALIDFRONT') {
                                                                        tempid = 'BOTSWANANATIONALIDFRONT - ID No';
                                                                        break;
                                                                    }
                                                                    if (orderarray[i] == 'BOTSWANANATIONALIDBACK') {
                                                                        tempid = 'BOTSWANANATIONALIDBACK - ID No';
                                                                        break;
                                                                    }
                                                                    if (orderarray[i] == 'INDIAPASSPORTFRONT') {
                                                                        tempid = 'INDIAPASSPORTFRONT - Passport No';
                                                                        console.log(tempid);
                                                                        break;
                                                                    }
                                                                } // End of the for loop
                                                                    

                                                                var varfathernameinkyc = "";
                                                                var tempfathername = "";
																
                                                                for (i = 0; i < orderarray.length; i++) {
                                                                    
                                                                        tempfathername = orderarray[i] + ' - Fathers Name';
                                                                    // }
                                                                    if (typeof fetchdataobjects[tempfathername] != 'undefined') {
                                                                        varfathernameinkyc = fetchdataobjects[tempfathername];
                                                                        await db.TbGenz.update(genzdata[0].PkId, { fathernameinkyc: varfathernameinkyc });
                                                                        break;
                                                                    }
                                                                }


                                                                var vardobinkyc = "";
                                                                var tempdob = "";
                                                                for (i = 0; i < orderarray.length; i++) {
                                                                    if (orderarray[i] == 'INDIAAADHARSHORT') {
                                                                        tempdob = 'INDIAAADHARSHORT - DOB';
                                                                    }
                                                                    else {
                                                                        tempdob = orderarray[i] + ' - Date of Birth'; //  - Date of Birth
                                                                       
                                                                    }
                                                                    if (typeof fetchdataobjects[tempdob] != 'undefined') {
                                                                    
                                                                        vardobinkyc = fetchdataobjects[tempdob];
                                                                        await db.TbGenz.update(genzdata[0].PkId, { dobinkyc: vardobinkyc });
                                                                        break;
                                                                    } 
                                                                        vardobinkyc = fetchdataobjects["UAEGCCBACK - Date of Birth"]
                                                                        await db.TbGenz.update(genzdata[0].PkId, { dobinkyc: vardobinkyc });
                                                                }




                                                                var varnationalitykyc = "";
                                                                var tempnationality = "";
                                                                for (i = 0; i < orderarray.length; i++) {
                                                                    tempnationality = orderarray[i] + ' - Nationality';
                                                                    if (typeof fetchdataobjects[tempnationality] != 'undefined') {
                                                                        varnationalitykyc = fetchdataobjects[tempnationality];
                                                                        await db.TbGenz.update(genzdata[0].PkId, { nationalityinkyc: varnationalitykyc });
                                                                        break;
                                                                    }
                                                                }

                                                               

                                                                if (typeof fetchdataobjects['INDIAPASSPORTFRONT - Place of Birth'] != 'undefined') {
                                                                    await db.TbGenz.update(genzdata[0].PkId, { placeofbirthinkyc: fetchdataobjects['INDIAPASSPORTFRONT - Place of Birth'] });
                                                                }

                                                                if (typeof fetchdataobjects['livenessstatus'] != 'undefined') {
                                                                    await db.TbGenz.update(genzdata[0].PkId, { liveness: fetchdataobjects['livenessstatus'] });
                                                                }


                                                                var varaddressinkyc = "";
                                                                var tempaddress = "";
                                                                for (var i = 0; i < orderarray.length; i++) {
                                                                        tempaddress = orderarray[i] + ' - Address';
                                                                    if (typeof fetchdataobjects[tempaddress] != 'undefined') {
                                                                        varaddressinkyc = fetchdataobjects[tempaddress];
                                                                        await db.TbGenz.update(genzdata[0].PkId, { passportaddressinkyc: varaddressinkyc });
                                                                        break;
                                                                    }
                                                                }
                                                                if (typeof fetchdataobjects['INDIAPASSPORT - Address1'] != 'undefined') {
                                                                   await db.TbGenz.update(genzdata[0].PkId, { passportaddressinkyc: fetchdataobjects['INDIAPASSPORT - Address1'] });
                                                                }

                                                                if (typeof fetchdataobjects['NATIONALID - Address'] != 'undefined') {
                                                                   await db.TbGenz.update(genzdata[0].PkId, { passportaddressinkyc: fetchdataobjects['NATIONALID - Address'] });
                                                                }

                                                                
                                                            }
                                                            methods.setFrontImgUploaded(false);
                                                            methods.setBckImgUploaded(false);
                                                            // this.$sunidhi.logoutBtnDisp = 'true';
                                                            router.push({ name: "HomeDataForm" });
                                                        } 
                                                        else {
                                                            // self.DocumentUploadFailureDailog1 = true; 
                                                        }
                                                    }
                                                },
                                                error: function (ex) {
                                                    console.log(ex);
                                                     self.kycFailureMsg = errorMsg ;
                                                        self.DocumentUploadFailureDailog1 = true;
                                                        self.processLoader = 6;
                                                        // $('#submitDocuments').show();
                                                        methods.setDisableUploadBtn(false);
                                                    
                                                }
                                            });
                                        },
                                        error: function () {
                                            
                                             self.kycFailureMsg = errorMsg ;
                                            self.DocumentUploadFailureDailog1 = true;
                                            self.processLoader = 6;
                                            // $('#submitDocuments').show();
                                            methods.setDisableUploadBtn(false);
                                        }
                                    }).done(function (data) {
                                        console.log(data);
                                    });
                                }
                                },
                                error: function (ex) {
                                    console.log(ex);
                                    self.UploadStatusMsg = errorMsg;
                                    self.UploadStatus = true;
                                    // $('#submitDocuments').show();
                                    methods.setDisableUploadBtn(false);
                                }
                                
                            });
                        }
                        },
                        error: function (ex) {
                            console.log(ex);
                            this.UploadStatusMsg = errorMsg;
                            this.UploadStatus = true;
                            // $('#submitDocuments').show();
                            methods.setDisableUploadBtn(false);
                        }
                    });
                } catch (error) {
                    this.UploadStatusMsg = errorMsg;
                    this.UploadStatus = true;
                    // $('#submitDocuments').show();
                    methods.setDisableUploadBtn(false);
                }
            }, 
            onready() {
                this.btnSubmit = true;
                // $('#submitDocuments').hide();
                state.isDisableUploadBtn = true;
                this.processLoader = 6;

                $("#capture1").change(function () {
                    // this.nationalIDFrontUploaded = false
                    this.uploadedImage1 = !!event.target.files[0]
                  readURL1(this);
                  if(this.value != ''){
                    this.nationalIDFrontUploaded = true;
                    // console.log("1:",this.nationalIDFrontUploaded)
                    // console.log("1:",this.nationalIDBackUploaded)
                    // console.log("1:::FRNOT",this.nationalIDFrontUploaded)
                    // console.log("1:::bck",this.nationalIDBackUploaded)
                    if(this.nationalIDFrontUploaded === true && this.nationalIDBackUploaded === true){
                        // $('#submitDocuments').show();
                        methods.setDisableUploadBtn(false);
                    }
                  }

                });

                $("#capture2").change(function () {
                    console.log(event.target.files[0])
                    this.uploadedImage2 = !!event.target.files[0]
                    readURL2(this);
                    var fileInput = $('#capture1')[0];
                    var fileInput2 = $('#capture2')[0];
                    this.nationalIDBackUploaded = true;

                    this.uploadedImage2 = event.target.files[0]
                    // console.log("2:",this.nationalIDFrontUploaded)
                    // console.log("2:",this.nationalIDBackUploaded)
                    // console.log("2:::FRNOT",this.nationalIDFrontUploaded)
                    // console.log("2:::bck",this.nationalIDBackUploaded)
                    
                    if(this.nationalIDFrontUploaded == true && this.nationalIDBackUploaded == true){
                        
                        // $('#submitDocuments').show();
                        methods.setDisableUploadBtn(false);
                    }

                   

                    

                    this.uploadedImage1 = fileInput.files.length;
                    this.uploadedImage2 = fileInput2.files.length;

                    console.log('fileInput.files.length::: ',!!fileInput);
                    console.log('fileInput2.files.length::: ', !!fileInput2);

                    if(fileInput.files.length !== 0 && fileInput2.files.length !== 0) {
                        console.log('Final btn is working')
                        // $('#final-btn').show()
                    } else {
                        console.log('Final btn is not working')
                        // $('#final-btn').hide()
                    }
                });
                $("#capture6").change(function () {
                    readURL4(this);
                });
                $("#capturenationalidback").change(function (event) {
                    console.log("eventback", event);
                    readURL10(this);
                });

            }
        }, 
        // beforeRouteLeave(to, from, next) {
        //     if (backbuttonpressed) {
        //         // if (confirm('You may have unsaved changes. Do you want to continue?')) {
        //         return next(false);
        //         //  }
        //     } else {
        //         return next();
        //     }
        // }
    }
</script>

<style type="text/css">

.KYCContainer{
    /* position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%); */
}

#capturedPhoto1{
    display: none;
}
#capturedPhoto2{
    display: none;
}

    .selfie {
        display: none;
    }

    .thumbnail {
        margin: 0 !important;
    }

    .logo_container {
        position: relative;
        bottom: 90px;
    }

    .play-area-sub {
  width: 320px !important;
  height: 240px !important;
  padding: 1em 1%;
  display: inline-block;
  text-align: center;
}

#capture {
  display: none;
}

#snapshot {
  display: inline-block;
  width: 320px;
  height: 240px;
}
 .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
	width:50%;
  }

  .modal-header,
  .modal-footer {
    padding: 15px;
    display: flex;
  }

  .modal-header {
    position: relative;
    border-bottom: 1px solid #eeeeee;
    color: #4AAE9B;
    justify-content: space-between;
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
    flex-direction: column;
    justify-content: flex-end;
  }

  .modal-body {
    position: relative;
    padding: 20px 10px;
  }

  .btn-close {
    position: absolute !important;
    top: 0 !important;
    right: 0 !important;
    border: none !important;
    font-size: 20px !important;
    padding: 10px !important;
    cursor: pointer !important;
    font-weight: bold !important;
    color: #b78b20 !important;
    background: transparent !important;
  }

  .btn-green {
    color: white;
    background: #4AAE9B;
    border: 1px solid #4AAE9B;
    border-radius: 2px;
  }
  .play-area-sub {
        position: relative;
    }
    .play-area-sub video { 
			width: 320px !important;
            height: 240px !important;
            position: absolute;
            top: 5%;
            left:1%;
            object-fit: cover;
        }
       .play-area-sub img {
            width: 320px !important;
            height: 240px !important;
            position: absolute;
            top: 5%;
            left:1%;
        }

    .v-overlay--active:before {
        opacity: 0.9 !important;
    }

    
    .v-dialog.v-dialog--active.v-dialog--persistent.v-dialog--scrollable + #KycErrorStatus {
        width: 60% !important;    
    }

    @media screen and (max-width: 540px) {
        .modal {
        width:100%;
        }
       
    }
</style>